import { Component, OnInit, Input } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';

@Component({
  selector: 'app-audit-score',
  templateUrl: './audit-score.component.html',
  styles: []
})
export class AuditScoreComponent extends ExcTranslation implements OnInit {
  @Input() small = false;
  @Input() Date;
  @Input() Score;
  @Input() MdtID;
  @Input() tooltipContent = null;
  @Input() Type = null;
  @Input() Auditor = null;
  constructor(private excDss: DefaultSettingsService) {
    super();
  }

  getTooltip() {
    // if (this.MdtID === null || this.MdtID === undefined) {
    //   return this.getRessource('Score_' + this.Score);
    // } else {
    //   let x =  this.getRessource('Score_' + this.Score + '_' + this.MdtID);
    //   if (x.indexOf( 'AuditScoreComponent.Score') > -1) {
    //       x = this.getRessource('Score_' + this.Score);
    //   }
    //   return x;
    // }
    if (this.MdtID === null || this.MdtID === undefined) {
      if (this.Score === undefined || this.Score === null) {
        return '';
      }
      let msg = this.getRessource('Score_' + this.Score);
      if (this.Type !== null) {
        msg += '\r\n\r\n' + this.getGlobal('AuditType_' + this.Type);
      }
      if (this.Auditor !== null) {
        msg += ': ' + this.Auditor;
      }
      return msg;
    } else {
      if (this.excDss.MandantSettings['ReviewRating'] !== undefined) {
        if (this.Score !== null) {
          if (this.Score === -1) {
            return this.getGlobal('NoRatingTitle');
          }
          let msg = this.excDss.MandantSettings['ReviewRating'][this.Score]['Title'] || this.getRessource('Score_' + this.Score);
          if (this.Type !== null) {
            msg += '\r\n\r\n' + this.getGlobal('AuditType_' + this.Type);
          }
          if (this.Auditor !== null) {
            msg += ': ' + this.Auditor;
          }
          return msg;
        } else {
          return '';
        }
      }
    }
  }

  getColor() {
    if (this.Score === null || this.Score === undefined || this.Score === 0) {
      return {backgroundColor: 'rgba(0,0,0,0.12)'};
    }
    if (this.excDss.MandantSettings['ReviewRating'][this.Score]) {
      return {backgroundColor: this.excDss.MandantSettings['ReviewRating'][this.Score]['Background'], color: this.excDss.MandantSettings['ReviewRating'][this.Score]['TextColor'] || 'white'};
    } else {
      switch (this.Score) {
        case 4:
          return {backgroundColor: 'rgb(240,0,0)', color: 'white'};
        case 3:
          return {backgroundColor: 'rgb(240,110,0)', color: 'white'};
        case 2:
          return {backgroundColor: 'rgb(240,240,0)', color: '#777'};
        case 1:
          return {backgroundColor: 'rgb(0,180,0)', color: 'white'};
        case 5:
          return {backgroundColor: 'rgb(0,0,210)', color: 'white'};
        case -1:
          return {backgroundColor: 'rgba(0,0,0,0.4)', color: 'white'};
        default:
          return {backgroundColor: 'rgba(0,0,0,0.5)', color: 'white'};
      }
    }
  }

  ngOnInit() {
  }

}
